// Canonical role identifiers.
// These must match exactly what the backend returns in `response.role`
// (surfaced on the store as `state.common.loggedUser.userRole`).
export const ROLES = {
  ADMIN: "Admin",
  AUDITOR: "Auditor",
  USER: "User",
  SETUP_ADMIN: "Setup Admin",
  // Approves and rejects onboarding requests, and does nothing else: Asset
  // Approval is the only page this role can reach.
  SUPERVISOR: "Supervisor",
};
